import React from "react";
import { showToast } from "./utils";
import ChatIcon from "./../components/ChatIcon";

import {
  resetObj,
  getMessages,
  startObserver,
  disableChat,
} from "../../../store/operator/actions";

import moment from "moment";
import { findLast, isArray } from "../../../Libs/CustomMethods/customMethods";
import MessageSystem from "../components/ActiveChat/subcomponents/messageSystem/messageSystem";
import MessageItem from "../components/PreviousConversations/subcomponents/MessageItem/MessageItem";

import {
  isClientMsg,
  isAgentMsg,
  isByEmployee,
  isPrivateMsg,
  isValidMsg,
} from "../functions/utils";

// efault idle message in case of payload comes without a valid message (client or agent)
export const defaultMsg = (chat) => ({
  text: "start",
  by: "consumer",
  sentTime: chat?.start,
});

export const checkMessages = (
  conn,
  buffer,
  setBuffer,
  handleNewMessageQueue,
  handleNewMessageTelegram,
  handleNewMessageFromAgent,
  handleNewMessageFromManager,
  handleNewMessagePrivate,
  setClosedByClient,
  setClosedByAgent,
  setClosedByManager,
  setClosedBySystem,
  setTransferedByManager,
  setTransferedBySystem,
  setTransferedByAgent,
  setInactiveBySystem,
  setJoinedManager,
  setEndPreChat,
  setEndPosChat,
  setReopenConversation,
  setReconnecting,
  history,
  spyConversationId,
  handleReconnected
) => {
  try {
    const signalRMethods = [
      { eventName: "newMessageQueue", callback: newMessageQueueChat },
      { eventName: "newMessageTelegram", callback: newMessageTelegramChat },
      { eventName: "newMessageFromAgent", callback: newMessageFromAgentChat },
      {
        eventName: "newMessageFromManager",
        callback: newMessageFromManagerChat,
      },
      { eventName: "newMessagePrivate", callback: newMessagePrivateChat },
      {
        eventName: "closeConversationByClient",
        callback: closeConversationByClientChat,
      },
      {
        eventName: "closeConversationByAgent",
        callback: closeConversationByAgentChat,
      },
      {
        eventName: "closeConversationByManager",
        callback: closeConversationByManagerChat,
      },
      {
        eventName: "closeConversationBySystem",
        callback: closeConversationBySystemChat,
      },
      {
        eventName: "transferConversationByAgent",
        callback: transferConversationByAgentChat,
      },
      {
        eventName: "transferConversationByManager",
        callback: transferConversationByManagerChat,
      },
      {
        eventName: "transferConversationBySystem",
        callback: transferConversationBySystemChat,
      },
      {
        eventName: "inactiveConversationBySystem",
        callback: inactiveConversationBySystemChat,
      },
      {
        eventName: "managerJoinToConversation",
        callback: managerJoinToConversationChat,
      },
      {
        eventName: "endPreChat",
        callback: endPreChat,
      },
      {
        eventName: "endPosChat",
        callback: endPosChat,
      },
      {
        eventName: "reopenConversation",
        callback: reopenConversation,
      },
    ];

    signalRMethods.forEach((item) => {
      removeSignalRMethods(conn, item.eventName, item.callback.name);
      conn.on(item.eventName, item.callback);
    });

    removeSignalRConnectionsCallBacks(
      conn.reconnectedCallbacks,
      onreconnectedChat.name
    );
    removeSignalRConnectionsCallBacks(conn.closedCallbacks, oncloseChat.name);
    conn.onreconnected(onreconnectedChat);
    conn.onclose(oncloseChat);
    conn.onreconnecting(setReconnecting);

    function removeSignalRMethods(obj, eventName, callbackName) {
      const e = obj.methods[eventName.toLowerCase()];

      if (e) {
        //obj.methods.hasOwnProperty(eventName.toLowerCase())
        let indexCallback = e.findIndex((item) => item.name === callbackName);
        while (indexCallback >= 0) {
          e.splice(indexCallback, 1);
          indexCallback = e.findIndex((item) => item.name === callbackName);
        }
      }
    }

    function removeSignalRConnectionsCallBacks(eventObject, callbackName) {
      let indexCallback = eventObject.findIndex(
        (item) => item.name === callbackName
      );
      while (indexCallback >= 0) {
        eventObject.splice(indexCallback, 1);
        indexCallback = eventObject.findIndex(
          (item) => item.name === callbackName
        );
      }
    }

    //#region SignalR Methods

    //When Agent revice a new Conversation
    function newMessageQueueChat(data) {
      handleNewMessageQueue(data, buffer, setBuffer, spyConversationId);
    }

    //When Client send a message (Altu, Telegram, etc) (sent to: Agent and Spys)
    function newMessageTelegramChat(data) {
      handleNewMessageTelegram(data, buffer, setBuffer, spyConversationId);
    }

    //When Agent send a message (sent to: Spys)
    function newMessageFromAgentChat(data) {
      handleNewMessageFromAgent(data, buffer, setBuffer, spyConversationId);
    }

    //When Manager send a message (sent to: Agent and Spys)
    function newMessageFromManagerChat(data) {
      handleNewMessageFromManager(data, buffer, setBuffer);
    }

    //When Agent or Manager send a message (sent to: Agent and Spys)
    function newMessagePrivateChat(data) {
      handleNewMessagePrivate(data, buffer, setBuffer, spyConversationId);
    }

    //When AltuClient close web widget (sent to: Agent and Spys)
    function closeConversationByClientChat(data) {
      if (history.location.pathname === "/chats") {
        setClosedByClient(data);
      }
    }

    //When Agent close chat (sent to: Spys)
    function closeConversationByAgentChat(data) {
      if (history.location.pathname === "/chats") {
        setClosedByAgent(data);
      }
    }

    //When Manager close chat (sent to: Agent and Spys)
    function closeConversationByManagerChat(data) {
      if (history.location.pathname === "/chats") {
        setClosedByManager(data);
      }
    }

    //When System close chat (sent to: Agent and Spys)
    function closeConversationBySystemChat(data) {
      if (history.location.pathname === "/chats") {
        setClosedBySystem(data);
      }
    }

    //When Agent transfer chat (sent to: Spys)
    function transferConversationByAgentChat(data) {
      if (history.location.pathname === "/chats") {
        setTransferedByAgent(data);
      }
    }

    //When Manager transfer chat (sent to: Agent and Spys)
    function transferConversationByManagerChat(data) {
      if (history.location.pathname === "/chats") {
        setTransferedByManager(data);
      }
    }

    //When System transfer chat (sent to: Agent and Spys)
    function transferConversationBySystemChat(data) {
      if (history.location.pathname === "/chats") {
        setTransferedBySystem(data);
      }
    }

    //When System inactive chat (sent to: Agent and Spys)
    function inactiveConversationBySystemChat(data) {
      if (history.location.pathname === "/chats") {
        setInactiveBySystem(data);
      }
    }

    //When Manager join chat (sent to: Agent and Spys)
    function managerJoinToConversationChat(data) {
      if (history.location.pathname === "/chats") {
        setJoinedManager(data);
      }
    }

    function endPreChat(data) {
      if (history.location.pathname === "/chats") {
        setEndPreChat(data);
      }
    }

    function endPosChat(data) {
      if (history.location.pathname === "/chats") {
        setEndPosChat(data);
      }
    }

    //When reopen conversation (accepted, answered)
    function reopenConversation(data) {
      if (history.location.pathname === "/chats") {
        setReopenConversation(data);
      }
    }

    function onreconnectedChat() {
      if (history.location.pathname === "/chats") {
        handleReconnected();
      }
    }

    function oncloseChat() {
      if (history.location.pathname === "/chats") {
        showToast(
          "error",
          "Cannot establish communication. Please check your Internet connection."
        );
      }
    }
    //#endregion
  } catch (error) {
    console.error(error);
  }
};

export const handleSLA = (chat, getChat, timePausedInSla = 0) => {
  if (['inactive', 'closed', 'pos-chat'].includes(chat?.status)) return chat.status;

  let msgs = getChat(chat?.conversationId)?.chat?.message;
  let lastValidMsg = findLast(msgs, isValidMsg) ?? defaultMsg(chat);

  if (!(chat?.slaLate && chat?.inactivityTime)) return null

  let now = moment();
  let msgTime = moment(chat?.firstWithoutAnswer?.time);
  let overdue = null;
  let bursting = null;
  let inactive = null;

  if (isClientMsg(lastValidMsg)) {
    overdue = msgTime.clone().add(parseInt(chat.slaLate), "seconds").add(timePausedInSla, 'milliseconds');
    bursting = overdue.clone().subtract(30, "seconds");
  } else {
    inactive = msgTime.clone().add(chat.inactivityTime, "seconds");
  }

  if (overdue) overdue.add(1, "second");

  if (overdue && now > overdue) return 'overdue'

  if (overdue && bursting && now > bursting && now <= overdue) return 'bursting'

  if ((bursting && now <= bursting) || (inactive && now <= inactive)) return 'normal'

  return 'inactive'
};

export const getActiveMsgs = (
  conversation,
  handleDayTitle,
  getSender,
  activeChat,
  chatImages,
  updateMsg,
  t
) => {
  return conversation.message.map((msg, key) => (
    <div key={key}>
      {handleDayTitle(conversation.message, key)}

      {msg?.unreadMsg ? (
        <MessageSystem
          // msg={`${unread} ${t("Unread messages")}`}
          msg={`${t("Unread messages")}`}
          striped={true}
          id="unreadMsg"
        />
      ) : (
        <MessageItem
          isRight={(msg?.userId || msg?.systemMessage) && true}
          name={getSender(conversation, msg)}
          message={msg?.text}
          msg={{ ...msg, chatId: activeChat?.conversation?.conversationId }}
          file={msg?.files}
          pics={chatImages}
          time={msg?.sentTime ?? msg?.sendTime}
          enableStarMsg={true}
          isSkillSummaryActived={activeChat?.conversation?.isAiSummaryEnabled}
          onChange={(e) => {
            let obj = {};
            switch (e?.action) {
              case "star_message":
                obj = {
                  currentId: e?.data?.currentId,
                  favorite: e?.data?.starred,
                };
                updateMsg(e?.data?.conversationId, obj);
                break;
              default:
                break;
            }
          }}
        />
      )}
    </div>
  ));
};

export const updateChangeStatus = (
  chatId,
  status,
  messageOperator,
  dispatch,
  setMessage
) => {
  if (messageOperator?.chats?.data) {
    let aux = messageOperator?.chats;

    if (aux?.data) {
      let pos = aux.data.findIndex((e) => e?.conversationId === chatId);

      if (pos >= 0) {
        aux.data[pos] = {
          ...aux.data[pos],
          status: status,
        };
        dispatch(setMessage(aux));
      }
    }
  }
};

export const setActiveChatByChatId = (
  chatId,
  messageOperator,
  setActiveChat,
  activeChat
) => {
  let aux = messageOperator?.chats?.data?.find(
    (chat) => chat.conversationId === chatId
  );
  if (aux) {
    setActiveChat(() => ({
      ...activeChat,
      conversation: aux,
      sendMessage: {
        ...activeChat.sendMessage,
        values: {
          text: "",
        },
      },
    }));
  }
};

export const handleInactivity = (
  chat,
  spyConversation,
  messageOperator,
  dispatch
) => {
  // TODO: Have an error here, problably chat?.status !== "inactive" but in back-end chat?.status === "inactive"
  if (!spyConversation && chat?.status !== "inactive") {
    let event = chat?.events?.disableChat;

    if (event?.countAttempts < event?.limitAttempts) {
      let status = messageOperator?.status?.disable_chat ?? null;

      if (!status || status?.error?.status) {
        event.countAttempts += 1;
        setTimeout(
          () =>
            dispatch(
              disableChat({
                chatId: chat?.conversationId,
                status: "inactive",
              })
            ),
          500
        );
      }
    }
  }
};

export const handleFilter = (
  chats,
  getChat,
  spyConversation,
  messageOperator,
  queueFilter,
  setQueueFilter,
  indicators,
  dispatch,
  getCsat,
  getNps,
  setHeaderIndicators
) => {
  // Filter
  let overdue = 0;
  let progress = 0;
  let inactive = 0;
  let closed = 0;

  // Header indicators
  let open = 0;
  let waiting = 0;
  let bursting = 0;

  chats.forEach((c) => {
    let status = handleSLA(c, getChat);
    if (
      c?.status !== "closed" &&
      c?.status !== "pos-chat" &&
      isByEmployee(c?.lastMessage) &&
      !isPrivateMsg(c?.lastMessage)
    )
      waiting++;

    switch (status) {
      case "overdue":
        overdue++;
        break;
      case "bursting":
        progress++;
        break;
      case "normal":
        progress++;
        break;
      case "inactive":
        inactive++;
        handleInactivity(c, spyConversation, messageOperator, dispatch);
        break;
      default:
        closed++;
        break;
    }
  });

  open = overdue + progress + inactive;
  bursting = progress - waiting > 0 ? progress - waiting : 0;

  if (
    queueFilter.overdue.qtd !== overdue ||
    queueFilter.progress.qtd !== progress ||
    queueFilter.inactive.qtd !== inactive ||
    queueFilter.closed.qtd !== closed
  ) {
    setQueueFilter(() => ({
      overdue: { ...queueFilter.overdue, qtd: overdue },
      progress: { ...queueFilter.progress, qtd: progress },
      inactive: { ...queueFilter.inactive, qtd: inactive },
      closed: { ...queueFilter.closed, qtd: closed },
    }));
  }
  if (
    indicators?.open !== open ||
    indicators?.waiting !== waiting ||
    indicators?.overdue !== overdue ||
    indicators?.bursting !== bursting
  ) {
    dispatch(getCsat());
    dispatch(getNps());
    dispatch(
      setHeaderIndicators({
        open: open,
        waiting: waiting,
        overdue: overdue,
        bursting: bursting,
      })
    );
  }
};

export const handleTime = (chat, getChat) => {
  let status = handleSLA(chat, getChat);

  let msgs = getChat(chat?.conversationId)?.chat?.message;
  let lastValidMsg = findLast(msgs, isValidMsg);

  if (
    status &&
    status !== "inactive" &&
    status !== "closed" &&
    status !== "pos-chat" &&
    !isAgentMsg(lastValidMsg)
  ) {
    return chat.timer;
  } else {
    return -1;
  }
};

export const handleStatusIcon = (conversation, getChat, inExceptionTimeOrOutsideOpeningHours = false, time = 0, timePausedInSla = 0) => {
  let status = handleSLA(conversation, getChat, timePausedInSla);
  if (inExceptionTimeOrOutsideOpeningHours && ['bursting', 'overdue', 'normal'].includes(status)) {
    if (time > 0)

      if (time <= 30) return ChatIcon("exception", { color: "#f1b44d" })

      else return ChatIcon("exception", { color: "#34c38f" })

    return ChatIcon("exception")
  }

  switch (status) {
    case "overdue":
      return ChatIcon("overdue");
    case "bursting":
      return ChatIcon("burstingTime");
    case "normal":
      return ChatIcon("progress");
    case "inactive":
      return ChatIcon("inactive");
    default:
      return ChatIcon("closed");
  }
};


/**
 * Will return an message to be used as a tooltip
 * @param {object} conversation 
 * @param {function} getChat 
 * @returns {string} translated message
 */
export const handleException = (conversation, getChat) => {
  let status = handleSLA(conversation, getChat);
  switch (status) {
    case "overdue":
      return "Overdue status, expecting agent response";
    case "bursting":
      return "Bursting status, almost going to overdue";
    case "normal":
      return "Normal status, conversation going as planned";
    case "closed":
      return "Closed status";
    default: return null
  }
}

export const sortQueue = (data, getChat) => {
  let sortedArray = [];

  const sortBy = (data, target) => {
    switch (target) {
      case "timer":
        data.sort((a, b) => {
          if (a.timer < b.timer) {
            return -1;
          }
          if (a.timer > b.timer) {
            return 1;
          }
          return 0;
        });
        break;
      case "assigned":
        data.sort((a, b) => {
          if (
            new Date(a.assignedTime).getTime() >
            new Date(b.assignedTime).getTime()
          ) {
            return -1;
          }
          if (
            new Date(a.assignedTime).getTime() <
            new Date(b.assignedTime).getTime()
          ) {
            return 1;
          }
          return 0;
        });
        break;
      default:
        break;
    }
    return data;
  };

  if (isArray(data)) {
    let arrayOverdue = [];
    let arrayBursting = [];
    let arrayNormal = [];
    let arrayInactive = [];
    let arrayClosed = [];

    data.forEach((c) => {
      if (c.status !== "closed" && c.status !== "pos-chat") {
        let status = handleSLA(c, getChat);
        switch (status) {
          case "overdue":
            arrayOverdue.push(c);
            break;
          case "bursting":
            arrayBursting.push(c);
            break;
          case "normal":
            arrayNormal.push(c);
            break;
          case "inactive":
            arrayInactive.push(c);
            break;
          default:
            break;
        }
      } else {
        arrayClosed.push(c);
      }
    });
    arrayOverdue = sortBy(arrayOverdue, "timer");
    arrayBursting = sortBy(arrayBursting, "timer");
    arrayNormal = sortBy(arrayNormal, "timer");
    arrayInactive = sortBy(arrayInactive, "assigned");
    arrayClosed = sortBy(arrayClosed, "assigned");

    sortedArray = [
      ...arrayOverdue,
      ...arrayBursting,
      ...arrayNormal,
      ...arrayInactive,
      ...arrayClosed,
    ];
  }

  return sortedArray;
};
